export default __webpack_public_path__ + "static/media/dash-icon-settings-white.02b70330.svg";